import { useState } from "react";
import uniqid from "uniqid";

const ButtonGroup = ({
  errors,
  askConfirmDelete,
  updateFunction,
  cancelFunction,
  canDelete,
}) => {
  const [submitting, setSubmitting] = useState(false);
  return (
    <div className="grid grid-cols-[min-content_repeat(3,1fr)] col-span-4 justify-self-end gap-x-2 items-center">
      <p className={`${errors.length ? "" : "invisible"} text-custom-red`}>
        {errors.map((error, index) => (
          <span key={uniqid()}>
            {`${index === 0 ? "" : ", "}${error.msg}`}{" "}
          </span>
        ))}
      </p>
      <button
        disabled={submitting}
        onClick={async () => {
          setSubmitting(true);
          await askConfirmDelete();
          setSubmitting(false);
        }}
        className={`bg-custom-red text-white rounded-full w-20 h-8 hover:brightness-75 disabled:opacity-75 ${canDelete ? "" : "invisible"}`}
      >
        刪除
      </button>
      <button
        disabled={submitting}
        onClick={async () => {
          setSubmitting(true);
          await updateFunction();
          setSubmitting(false);
        }}
        className="bg-custom-orange text-white rounded-full w-20 h-8 hover:brightness-75 disabled:opacity-75"
      >
        儲存
      </button>
      <button
        disabled={submitting}
        onClick={cancelFunction}
        className="bg-custom-gray text-white rounded-full w-20 h-8 hover:brightness-75 disabled:opacity-75"
      >
        取消
      </button>
    </div>
  );
};

export default ButtonGroup;
